import Axios from 'axios';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Logout from '../logout/logout';
import './customer_agreement.scss';
import { UserPermissionsContext } from '../../context/user_permission';

import Button from '../components/buttons/button';
import CardContainer from '../components/container/card_container';

class Agreement extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.onAgreeClick = this.onAgreeClick.bind(this);
  }

  static contextType = UserPermissionsContext;

  componentDidMount() {
    let content = document.getElementById('content');
    if (content) {
      content.id = 'content-alt';
    }
  }

  onAgreeClick(event) {
    Axios({
      url: `/apiV2/agreement`,
      method: 'POST',
    }).then((response) => {
      const { fetchUserPermissions } = this.context;
      fetchUserPermissions();
    });
  }

  /**
   * Displays customer agreement message
   * @function
   * @param {boolean} is_new - Indicator for messageType === 'new'
   * @return {JSX} - JSX for message
   */
  displayMessage = (is_new) => {
    const message =
      'All providers must review and accept the updated Customer Agreement with Lorelli Technologies LLC. By proceeding, you acknowledge that you have read, understood, and agreed to the updated';
    return (
      <>
        <p>
          {message}{' '}
          <a
            className="underlined"
            href={is_new ? `/agreement/${this.props.token}` : '/portal/agreement'}
            onClick={is_new ? this.props.onLinkClick : null}
            target="_blank"
            rel="noopener noreferrer"
          >
            Customer Agreement
          </a>
          ,{' '}
          <a className="underlined" href="https://www.insmilebraces.com/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a className="underlined" href="https://www.insmilebraces.com/terms-of-service" target="_blank" rel="noopener noreferrer">
            Terms and Conditions
          </a>
        </p>
      </>
    );
  };

  render() {
    const is_new = this.props.messageType === 'new';
    return (
      <div className={is_new ? 'ipp-light background' : ''}>
        <Helmet>
          <title>Agreement | InSmile™ Braces Portal</title>
        </Helmet>
        <div className="content--fullscreen center">
          <CardContainer className={`${is_new ? ' card--no-top-border' : 'card--customer-agreement'}`} type="message">
            {is_new ? (
              <>
                <h3>Welcome to InSmile Braces</h3>
                {this.displayMessage(is_new)}
                <Button type="submit" onClick={this.props.onNewAgreeClick}>
                  I Agree
                </Button>
                <a href="/" type="submit">
                  <Button theme="grey">Return</Button>
                </a>
              </>
            ) : (
              <>
                <h3>Customer Agreement, Policies and Terms</h3>
                {this.displayMessage(is_new)}
                <Button type="submit" onClick={this.onAgreeClick}>
                  Agree
                </Button>
                <Logout name="Cancel" />
              </>
            )}
          </CardContainer>
        </div>
      </div>
    );
  }
}

export default withRouter(Agreement);
